import { useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { Banner } from '@/components/ui/banner'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { invalidateFillApplication } from '@/models/fillApplication'
import { FmcsaStep } from './FmcsaStep'

interface ChangeDotDialogProps {
  orgId: string
  open: boolean
  onOpenChange: (open: boolean) => void
  currentDot: string
}

export function ChangeDotDialog({ orgId, open, onOpenChange, currentDot }: ChangeDotDialogProps) {
  const queryClient = useQueryClient()

  async function handleSaved() {
    onOpenChange(false)
    toast.success('DOT changed')
    await invalidateFillApplication(queryClient, orgId)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent size="lg">
        <DialogHeader>
          <DialogTitle>Change the DOT</DialogTitle>
          <DialogDescription>Nothing changes until you pick the new carrier.</DialogDescription>
        </DialogHeader>
        <Banner variant="warning" small>
          Using a new DOT clears the trucks and trailers, the travel distance, the FMCSA details, and any
          coverage-lapse flags and reason.
        </Banner>
        {/* Mounted only while open, so each opening starts from the DOT on file. */}
        {open && <FmcsaStep orgId={orgId} initialDot={currentDot} onSaved={() => void handleSaved()} />}
      </DialogContent>
    </Dialog>
  )
}
